<button
  type="button"
  mat-icon-button
  [matMenuTriggerFor]="followersMenu"
  [matTooltip]="
    isCurrentUserFollowing()
      ? 'Following this referral'
      : 'Follow this referral'
  "
>
  @if (isCurrentUserFollowing()) {
    <mat-icon
      color="primary"
      matBadgeSize="small"
      [matBadge]="followerCount()"
      [matBadgeHidden]="followerCount() === 0"
    >
      notifications
    </mat-icon>
  } @else {
    <mat-icon
      matBadgeSize="small"
      [matBadge]="followerCount()"
      [matBadgeHidden]="followerCount() === 0"
    >
      notifications_none
    </mat-icon>
  }
</button>

<mat-menu #followersMenu="matMenu" class="followers-menu">
  <div
    class="flex w-72 flex-col"
    (click)="$event.stopPropagation()"
    (keydown)="onMenuKeydown($event)"
  >
    @if (isCurrentUserStaffer()) {
      <div class="flex flex-col gap-1 px-3 py-2">
        <div class="flex items-center justify-between">
          <span class="text-sm font-medium">Follow</span>
          <mat-slide-toggle
            class="!scale-75"
            [checked]="isCurrentUserFollowing()"
            (change)="toggleFollow()"
          />
        </div>
        <div class="text-xs text-gray-500">Track updates to this referral</div>
      </div>
    }

    <mat-divider />

    <div class="px-3 py-2">
      <input
        type="text"
        class="focus:border-primary-500 w-full rounded border border-gray-300 px-2 py-1 text-sm outline-none"
        placeholder="Search..."
        [value]="searchQuery()"
        (input)="onSearchInput($event)"
      />
    </div>

    <mat-divider />

    <div class="px-3 py-1">
      <span class="py-1 text-[10px] uppercase text-gray-400">Followers</span>
    </div>
    @if (filteredFollowers().length > 0) {
      @for (follower of filteredFollowers(); track follower.ref.path) {
        <div
          class="flex items-center justify-between px-3 py-1.5 hover:bg-gray-50"
        >
          <div class="flex items-center gap-2">
            <pt-user-icon
              [name]="follower.name"
              [src]="follower.ref | map: getStafferImage$ : this | async"
              [diameter]="24"
            />
            <span class="text-sm">{{ follower.name }}</span>
          </div>
          <button
            type="button"
            class="flex h-6 w-6 items-center justify-center rounded-full hover:bg-gray-200"
            matTooltip="Remove follower"
            (click)="removeFollower(follower)"
          >
            <mat-icon class="!h-4 !w-4 !text-[16px] !leading-4 text-gray-400"
              >close</mat-icon
            >
          </button>
        </div>
      }
    } @else {
      <div class="px-3 py-1.5">
        <span class="text-sm text-gray-400">No followers</span>
      </div>
    }

    <mat-divider />

    <div class="max-h-48 overflow-auto">
      <div class="px-3 py-1">
        <span class="py-1 text-[10px] uppercase text-gray-400">Staff</span>
      </div>
      @if (filteredStaff().length > 0) {
        @for (staffer of filteredStaff(); track staffer.ref.path) {
          <button
            type="button"
            class="flex w-full items-center gap-2 px-3 py-1.5 text-left hover:bg-gray-50"
            (click)="addFollower(staffer)"
          >
            <pt-user-icon
              [name]="staffer.user.name"
              [src]="staffer.ref | map: getStafferImage$ : this | async"
              [diameter]="24"
            />
            <span class="text-sm">{{ staffer.user.name }}</span>
          </button>
        }
      } @else {
        <div class="px-3 py-1.5">
          <span class="text-sm text-gray-400">No staff available</span>
        </div>
      }

      <div class="px-3 py-1">
        <span class="py-1 text-[10px] uppercase text-gray-400">Teams</span>
      </div>
      @if (filteredTeams().length > 0) {
        @for (team of filteredTeams(); track team.ref.path) {
          <button
            type="button"
            class="flex w-full items-center gap-2 px-3 py-1.5 text-left hover:bg-gray-50"
            (click)="addTeamFollowers(team)"
          >
            <pt-user-icon [name]="team.name" [diameter]="24" />
            <span class="text-sm">{{ team.name }}</span>
          </button>
        }
      } @else {
        <div class="px-3 py-1.5">
          <span class="text-sm text-gray-400">No teams available</span>
        </div>
      }
    </div>
  </div>
</mat-menu>
